<template>
    <v-sheet>
        <v-row no-gutters class="mb-12 mb-lg-20">
            <v-col>
                <v-row class="row--small page-text">
                    <v-col cols="auto">
                        <p class="font-weight-medium">선택 근무지:</p>
                    </v-col>
                    <v-col cols="auto">
                        <p class="grey-6--text">{{ place.title }}</p>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="auto">
                <v-btn small dark color="green" class="w-md-160px" @click="excel">
                    엑셀파일 다운로드 <v-icon size="18" class="ml-4">mdi-tray-arrow-down</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-divider class="primary border-2" />
        <template>
            <v-data-table v-bind="{ items, headers }" disable-filtering disable-pagination disable-sort hide-default-footer :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
            </v-data-table>
             <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </template>
        <!-- <template v-else>
            <p class="page-text grey-6--text text-center">
                안녕하세요, 담당자님. <br />
                근무 현황이 없습니다.
            </p>
        </template> -->
    </v-sheet>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';
import XLSX from "xlsx";

const headers = [
    { width: 120, text: "날짜", value: "date", align: "center" },
    { width: 100, text: "이름", value: "name", align: "center" },
    { width: 160, text: "연락처", value: "phone", align: "center" },
    { width: "36%", text: "계약서명", value: "form", align: "center" },
    { width: "25%", text: "근무지", value: "place", align: "center" },
    { width: 100, text: "출근", value: "attendedAt", align: "center" },
    { width: 100, text: "퇴근", value: "departedAt", align: "center" },
].map((item) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-") }));

export default {
    data: () => ({
        limit:10,
        summary: { totalCount: 0 },
        headers,

        items: [],
        attendances: [],
        place: {}
    }),
    computed: {
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            const { ...query } = this.$route.query;
            if (query.page) delete query.page;
            if (query.page != this.$route.query.page) {
                this.$router.replace({ query });
            }
            this.placeSearch();
            this.$nextTick(this.search);
        },
        async search(){
            try {
                let { skip, limit, params } = this;
                const { summary, attendances } = await api.v1.company.employment.attendances.gets({
                    headers: { skip, limit },
                    params:{
                        ...params,
                        _place: this.$route.params.place
                    }
                })

                this.summary = summary;
                this.attendances = attendances;
                this.dataTableItems();
            } catch (e){
                console.error(e);
            }
        },
        dataTableItems(){
            this.items=[];
            for (let attendance of this.attendances){
                this.items.push({
                    date: dayjs(attendance?.date).format("YYYY-MM-DD"),
                    name: attendance?.applications?.resume?.personalInformation?.name,
                    phone: attendance?.applications?.resume?.personalInformation?.phone,
                    form: attendance?.contract?.form?.name,
                    place: attendance?.contract?.employment?.place?.title,
                    attendedAt: attendance?.attendedAt ? dayjs(attendance?.attendedAt).format("HH:mm") : "-",
                    departedAt: attendance?.departedAt ? dayjs(attendance?.departedAt).format("HH:mm") : "-",
                })
            }
        },
        async placeSearch(){
            let { place } = this.$route.params;
            let placeInfo = await api.v1.company.employment.places.get({ _id: place });
            
            this.place = placeInfo.place;
        },
        async excel(){
            try{
                let { params } = this;
                const { attendances } = await api.v1.company.employment.attendances.gets({
                    params:{
                        ...params,
                        _place: this.$route.params.place
                    }
                })

                if(!attendances?.length) throw new Error("출력할 항목이 없습니다.");
                
                let rows = attendances.map((attendance)=>({
                    날짜: dayjs(attendance?.date).format("YYYY-MM-DD") || "-",
                    이름: attendance?.applications?.resume?.personalInformation?.name || "-",
                    연락처: attendance?.applications?.resume?.personalInformation?.phone || "-",
                    계약서명: attendance?.contract?.form?.name || "-",
                    근무지: attendance?.contract?.employment?.place?.title || "-",
                    출근: attendance?.attendedAt ? dayjs(attendance?.attendedAt).format("HH:mm") : "-",
                    퇴근: attendance?.departedAt ? dayjs(attendance?.departedAt).format("HH:mm") : "-",
                }))

                let dateTime = dayjs().format("YYYYMMDD");
                let workbook = new XLSX.utils.book_new();
                let worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, `근무지 근무 현황-${dateTime}.xlsx`);
            } catch (error){
                console.error(error);
                alert(error?.message);
            }
        }
    },
    watch:{
        params() {
            this.search();
            this.placeSearch()
        },
        limit() {
            this.init();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>